<template>
	<div class="lobby flex-center">
		<Top ref="top" :showMenuType="showMenu" class="m-bg-1" :style="{ background: homeType ? 'rgba(0,0,0,.7)' : 'none' }" @emitProduct='emitProduct' @selectType="selectType" @openDownload="openDownload" @emitNews='emitNews'></Top>
    				<div id="bg1" class="gif-bg" ></div>

    <div class="box-content" @click="selectType(false)">

      <div class="box-flex-1 flex-aline-center view-box"><View1 /></div>
      <div class="box-flex-1 flex-aline-center view-box"><View2 /></div>
      <div class="box-flex-1 flex-aline-center view-box"><View3 /></div>
      <div class="box-flex-1 flex-aline-center view-box"><View4 /></div>
      <div class="box-flex-1 flex-aline-center view-box"><View5 /></div>
      <!-- <div class="box-flex-1 flex-aline-center view-box"><View6 /></div> -->
      <div class="box-flex-1 flex-aline-center view-box"><View7 /></div>
      <div class="box-flex-1 flex-aline-center view-box"><View8 /></div>
      <div class="box-flex-1 flex-aline-center view-box"><View9 /></div>
      <div class="box-flex-1 flex-aline-center view-box"><View10 /></div>
      <div class="box-flex-1 flex-aline-center view-box"><View11 /></div>
      <div class="box-flex-1 flex-aline-center view-box"><View12 /><Footer /></div>
    </div>

		<transition name="fade">
			<Product v-if="showProduct" />
		</transition>
    <transition name="fade">
			<DownloadComponent v-if="showDownload" />
		</transition>
    <transition name="fade">
      <appMeny v-if="showMenu" @emitNews='emitNews' @closeMenu="selectType" />
    </transition>
	</div>
</template>

<script>
// import {
//   Swiper,
//   SwiperSlide
// } from 'vue-awesome-swiper'

// import 'swiper/swiper-bundle.css'
// import SwiperCore, {
//   Pagination,
//   Mousewheel
// } from 'swiper'
import {
  mapState
} from 'vuex'
// 使用 Mousewheel 模块
// SwiperCore.use([Pagination, Mousewheel])
import Product from '../Help/index.vue'
import DownloadComponent from '../Download/index.vue'
import Top from '../public/top.vue'
import Footer from '../public/footer.vue'
import appMeny from '../public/app-menu.vue'

import View1 from './components1030/view1.vue'
import View2 from './components1030/view2.vue'
import View3 from './components1030/view3.vue'
import View4 from './components1030/view4.vue'
import View5 from './components1030/view5.vue'
import View6 from './components1030/view6.vue'
import View7 from './components1030/view7.vue'
import View8 from './components1030/view8.vue'
import View9 from './components1030/view9.vue'
import View10 from './components1030/view10.vue'
import View11 from './components1030/view11.vue'
import View12 from './components1030/view12.vue'



export default {
  computed: mapState({
    screenSize (state) {
      return state.screenSize
    },
    common (state) {
      return state.common
    }
  }),
  components: {
    Top,
    Product,
    appMeny,
    DownloadComponent,
    Footer,

    View1,
    View2,
    View3,
    View4,
    View5,
    View6,
    View7,
    View8,
    View9,
    View10,
    View11,
    View12,
  },
  data () {
    return {
      swiperOptions: {
        direction: 'vertical', // 设置 Swiper 为竖向滚动
        slidesPerView: 1, // 每次只显示一屏
        spaceBetween: 0, // 幻灯片之间的间距为 0
        mousewheel: {
          enabled: true,
          sensitivity: 0.01, // 调整灵敏度，值越小越不灵敏
          releaseOnEdges: true // 启用释放边缘停止滑动
        },
        pagination: {
          el: '.swiper-pagination',
          clickable: true
        }
      },
      homeType:false,
      currentIndex: 0,
      swiper: null,
      showProduct: false,
      local: localStorage.getItem('locale') || 'en',
      showMenu:false,
      showDownload:false,
      isPlaying: false,
      videoUrl: '',
    }
  },
  mounted () {
    let localType = localStorage.getItem('locale') || 'en'
    let enUrl = 'https://drag2.s3.ap-east-1.amazonaws.com/neco/video/mv_en.mp4'
    let zhUrl = 'https://drag2.s3.ap-east-1.amazonaws.com/neco/video/mv_cn.mp4'
    this.videoUrl = localType === 'zh_CN' ? zhUrl : enUrl
    window.addEventListener('keydown', this.handleKeyDown)
    window.addEventListener('scroll', this.handleScroll)
    const bgConfigs = [
      {id: 'bg0', colors: ['#1D4600', '#152900', '#005232', '#000f07']},
      {id: 'bg1', colors: ['#1D4600', '#152900', '#005232', '#000f07']},
      {id: 'bg2', colors: ['#1D4600', '#152900', '#005232', '#000f07']},
      {id: 'bg3', colors: ['#1D4600', '#152900', '#005232', '#000f07']},
      {id: 'bg4', colors: ['#1D4600', '#152900', '#005232', '#000f07']},
      {id: 'bg5', colors: ['#1D4600', '#152900', '#005232', '#000f07']},
      {id: 'bg6', colors: ['#1D4600', '#152900', '#005232', '#000f07']},
      {id: 'bg7', colors: ['#1D4600', '#152900', '#005232', '#000f07']},
      {id: 'bg8', colors: ['#1D4600', '#152900', '#005232', '#000f07']},
      {id: 'bg9', colors: ['#1D4600', '#152900', '#005232', '#000f07']},
      {id: 'bg10', colors: ['#1D4600', '#152900', '#005232', '#000f07']},
      {id: 'bg11', colors: ['#1D4600', '#152900', '#005232', '#000f07']},

    ];

    bgConfigs.forEach((config, index) => {
      setTimeout(() => {
        new Color4Bg.BlurGradientBg({
          dom: config.id,
          colors: config.colors,
          loop: true
        });
      }, index * 50); // 间隔50ms创建每个实例
    });
    this.local = localStorage.getItem('locale')
    console.log(this.local)
  },
  watch: {
    currentIndex (n) {
      console.log(n)
    },
  },
  methods: {
    handleKeyDown(e) {
      // this.homeType=!this.homeType
    },
    playVideo() {
      const video = this.$refs.homeVideo;
      if (video) {
        video.play();
        this.isPlaying = true;
      }
    },
    openHomeType(){
      // if(this.homeType){
      //   this.homeType=false
      // }else{
      //   console.log(11)
      //   this.homeType = false
      //   this.$nextTick(() => {
      //     this.homeType = true
      //   })
      // }
    },
    emitProduct (type) {
      console.log(type)
      this.showProduct = type
    },
    selectType(type){
      this.showMenu = type
    },
    emitNews () {
      // this.swiper.slideTo(this.swiper.slides.length - 1) // 跳转到最后一个 slide
      window.scrollTo(0, document.body.scrollHeight);
    },
    openDownload(type){
      this.showDownload = type

    },
    handleScroll() {
      if (window.scrollY < 100) {
        if (this.homeType) {
          this.homeType = false
        }
      } else {
        if (!this.homeType) {
          this.homeType = true
        }
      }
    },
  }
}
</script>

<style scoped>
	@media screen and (max-width: 768px) {
		.app-model {
			width: 100%;
			height: 100vh;
			overflow-x: hidden;
			overflow-y: auto;
		}
    .app-pagination {

      display: flex;
      flex-direction: row;
      position: absolute;
      bottom: 40px;
    }
    .small-title {
      font-size: 1rem!important;
      text-align: center;
    }

		.lobby-title {
			letter-spacing: 0 !important;
			text-align: center;
		}

    .lobby {
      overflow-x: hidden;
    }

		/*.font200 {*/
		/*	font-size: 1.7rem;*/
		/*}*/

		.appfont14 {
			font-size: 14px !important;
			line-height: 18px !important;
		}
    .width-sort {
      width: 80%!important;
      line-height: .33rem;
    }

		.margin61 {
			width: calc(100% - 30px);
			padding: 0 15px;
		}
    .vedio2{
      width: 100vw;
      /*height: 100%;*/
      /*position: absolute;*/
      /*top: 100px;*/
      position: relative;
      z-index: 3!important;
      margin-top: 100px;

    }
    .content-box {
      height: 100%;
      justify-content: start!important;
      height: fit-content!important;
      overflow: auto;
    }
    .top-logo{
      width: 136px;
      height: 61px;
      position: absolute;
      top: 110px;
      left: 10px;
      z-index: 10;
    }
    .play-button {
      display: none !important;
    }
    .mein-video-box {
      height: 55vw !important;
    }
    .box-flex-1 {
      width: 100vw !important;
    }
    .slide9 {
      height: auto !important;
    }

    .view-box {
      padding: 0 17px !important;
    }
    .view-box-100 {
      width: 100% !important;
      padding: 0 !important;
      height: auto !important;
    }
    .m-bg-1 {
        background: rgba(0,0,0,.7) !important;
    }
  }

	.lobby {
		width: 100%;
		height: 100vh;
		position: relative;
	}

  .box-content {
    position: absolute;
    top: 0;
    left: 0;
    z-index: 1;
  }

	.swiper-container {
		width: 100%;
		height: 100vh;
	}

	.swiper-slide {
		width: 100%;
		height: 100vh;
		position: relative;
		/*background: linear-gradient(125deg, #00301D 37.98%, #000303 100%);*/
		/* overflow: hidden; */
		overflow-y: auto;
	}

	.left-video {
		width: 9.83rem;
		height: 9.83rem;
		position: absolute;
		bottom: -4.915rem;
		left: -4.915rem;
		z-index: 2;
	}

	.right-video {
		width: 6.85rem;
		height: 3.85rem;
		position: absolute;
		bottom: -1.6rem;
		right: -1.74rem;
		z-index: 2;
	}

	.video-background {
		width: 100%;
		height: 100%;
		position: absolute;
		top: 0;
		left: 0;
		overflow: hidden;
		z-index: 1;
	}

	.gif-bg {
		width: 100%;
		height: 100%;
		position: fixed;
		top: 0;
		left: 0;
		z-index: 1;
	}
  .gif-bg2{
    width: 100%;
    height: 100%;
    background: rgba(0,0,0,.7);
    position: fixed;
    top: 0;
    left: 0;
    z-index: 3;
  }

	.vedio-lobby {
		width: 100%;
		height: 100vh;
		object-fit: cover;
	}

	.pagination {

		display: flex;
		flex-direction: column;
		position: absolute;
		left: 40px;
	}

	.default-item {
		width: .16rem;
		height: .16rem;
		border-radius: 50%;
		background: rgba(255, 255, 255, 0.10);
	}

	.active {
		width: .16rem;
		height: .16rem;
		border-radius: 50%;
		box-sizing: border-box;
		border: 1px solid #fff;
	}

	.content-box {
		width: 100%;
		height: 100%;
		position: relative;
		display: flex;
		align-items: center;
		justify-content: center;
		z-index: 3;
	}

	.lobby-title {
		/*letter-spacing: 1.2rem;*/
		text-align: center;
	}

	.small-title {
		font-size: .7rem;
		text-align: center;

	}

	.small-letter {
		letter-spacing: .57rem;
	}

	.font36 {
		font-size: .36rem;
	}

	.zero {
		width: .1rem;
		height: .1rem;
		background: #fff;
		border-radius: 50%;
	}

	.margin61 {
		margin: .24rem 0;
	}

	.width-sort {
		width: 10rem;
		line-height: .33rem;
	}
  .home-icon{
    width: 2.04rem;
    height: 2.1rem;
    flex-shrink: 0;
    z-index: 1;

  }
  .font64{
    font-size: .64rem;
    margin-top: .6rem;
  }
  .white54{
    color: rgba(255,255,255,.5);
  }
  .vedio1{
    width: 100%;
    height: 100%;
    object-fit: cover;
    position: absolute;
    z-index: 1;
    /* position: fixed;
    top: 0;
    left: 0;
    z-index: 2; */
  }
  /* ---------- 通用动画时长 ---------- */
  .slide-up-enter-active,
  .slide-up-leave-active,
  .slide-up-appear-active {
    transition: transform 2s cubic-bezier(.22,1,.36,1), opacity 2s;
    will-change: transform, opacity;
  }

  /* ======= 进入/出现时，元素从下方滑入 ======= */
  .slide-up-enter,
  .slide-up-appear {
    transform: translateY(100%);
    opacity: 0;
  }

  .slide-up-enter-to,
  .slide-up-appear-to {
    transform: translateY(0);
    opacity: 1;
  }

  /* ======= 离开动画，元素从当前位置滑出 ======= */
  .slide-up-leave-to {
    transform: translateY(100%);  /* 让元素滑出到视图底部 */
    opacity: 0;
  }

  .video-container {
    position: relative;
    width: 100%;
    height: 100%;
  }

  .play-button {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    background: rgba(0, 0, 0, 0.7);
    border-radius: 50%;
    width: 80px;
    height: 80px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    z-index: 10;
    font-size: 30px;
    color: white;
    border: 2px solid white;
  }

  .play-button:hover {
    background: rgba(0, 0, 0, 0.9);
  }

  .box-flex-1 {
    position: relative;
    width: calc(100vw - 20px);
    height: 100vh;
  }


  /* 新 */
  .view-box {
    padding: 0 10% 0 12%;
    width: 100%;
    box-sizing: border-box;
    position: relative;
  }

  .view-box-100 {
    padding: 0;
  }

  @media screen and (min-width: 768px) and (max-width: 1200px) {
    .view-box {
      padding: 0 4% 0 6%;
    }
    .view-box-100 {
      padding: 0;
    }
  }
  @media screen and (min-width: 1200px) and (max-width: 1700px) {
    .view-box {
      padding: 0 6% 0 8%;
    }
    .view-box-100 {
      padding: 0;
    }
  }
  @media screen and (min-width: 1700px) and (max-width: 2160px) {
    .view-box {
      padding: 0 8% 0 10%;
    }
    .view-box-100 {
      padding: 0;
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/lobby/index.vue